import { render, staticRenderFns } from "./PersonnelRecordDetailCardContent.vue?vue&type=template&id=79069aef"
import script from "./PersonnelRecordDetailCardContent.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports